import { useEffect, useState } from "react";

interface WindowSizeProps {
  width: number;
  height: number;
  desktop: boolean;
}

export function useWindowSize(): WindowSizeProps {
  const [windowSize, setWindowSize] = useState<WindowSizeProps>({
    width: 0,
    height: 0,
    desktop: true,
  });
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
        desktop: window.innerWidth > 1200,
      });
    }

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowSize;
}
